import React, { useState, useEffect } from 'react'
import ButtonizedInput from '../../atoms/ButtonizedInput/ButtonizedInput'
import Modal from '../../atoms/Modal/Modal'
import styles from './readingMrSelector.module.scss'

const ReadingMrSelector = ({ setSelectedReadingMr, taggedMrs = [], selectedReadingMr }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedOption, setSelectedOption] = useState({})
  const [isFirstLoad, setIsFirstLoad] = useState(true)

  useEffect(() => {
    if (isFirstLoad) {
      setIsFirstLoad(false)
    }
    if (!isFirstLoad) {
      if (taggedMrs.find(mr => mr.value === selectedReadingMr)?.value !== selectedReadingMr) {
        setSelectedOption({}) // Reset selected option if the MR is removed from tagged MRs
        setSelectedReadingMr('')
      }
    }
  }, [JSON.stringify(taggedMrs)])

  useEffect(() => {
    setSelectedOption({
      label: taggedMrs.find(mr => mr.value === selectedReadingMr)?.label,
      value: selectedReadingMr
    })
  }, [modalOpen])

  // On removal of tagged MRs, if the MR is selected as reading MR, remove it from the selected options
  const handleButtonizedInputClick = () => {
    // Open the modal when the buttonized input is clicked
    setModalOpen(true)
  }

  const handleSelectedOptions = (mr) => {
    setSelectedOption(mr)
  }

  const handleOkAction = () => {
    // Close the modal and set the selected tagged MRs in the parent component
    // Format the selected options to match the expected structure
    const formattedOptions = selectedOption.value
    setSelectedReadingMr(formattedOptions)
    setModalOpen(false)
  }

  return (
    <div>
      <ButtonizedInput
        label='TC Reading MR'
        placeholder='Select a TC Reading MR'
        onClick={handleButtonizedInputClick}
        value={selectedReadingMr ? [taggedMrs.find(mr => mr.value === selectedReadingMr)?.label] : []}
      />
      <Modal
        title='Select an MR Reading this TC'
        visible={modalOpen}
        onModalClose={() => setModalOpen(false)}
        okAction={handleOkAction}
      >
        {(taggedMrs.length > 0
          ? taggedMrs.map(({ label, value }, index) => (
            <label className={styles.label} key={value}>
              <input
                className={styles.checkbox}
                type='radio'
                checked={selectedOption.value === value}
                onChange={(e) => handleSelectedOptions({ label, value })}
              />
              {label ?? '-----'}
            </label>
          ))
          : <div className='text-center'>No MRs found. Please select at least one MR in tagged MRs field.</div>
            )}

      </Modal>
    </div>
  )
}

export default ReadingMrSelector
